// extracted by mini-css-extract-plugin
export default {"button":"Button_button__N289O","small":"Button_small__maEKX","text":"Button_text__OgRWg","negative":"Button_negative__zGZO7"};